import { TraitsResultProps, useEditor } from "@grapesjs/react";
import { Alert, Box, Grid } from "@mui/material";
import LightningLanderTraitsField from "features/lightningLanders/components/LightningLanderTraitsField";
import { useEffect, useState } from "react";

function LightningLandersTraits({
  traits,
}: Omit<TraitsResultProps, "Container">) {
  const editor = useEditor();
  const [selected, setSelected] = useState(() => editor?.getSelected() ?? null);

  useEffect(() => {
    if (!editor) return;
    const updateSelected = () => setSelected(editor.getSelected() ?? null);
    editor.on("component:select", updateSelected);
    editor.on("component:update:traits", updateSelected);
    return () => {
      editor.off("component:select", updateSelected);
      editor.off("component:update:traits", updateSelected);
    };
  }, [editor]);

  // Use selected to get the current traits, fallback to props.traits if not available
  const currentTraits = selected?.getTraits ? selected.getTraits() : traits;

  return (
    <Box p={2}>
      <Grid spacing={2} container>
        {!currentTraits.length ? (
          <Alert severity="info">No properties available</Alert>
        ) : (
          currentTraits.map((trait: any) => (
            <LightningLanderTraitsField key={trait.getId()} trait={trait} />
          ))
        )}
      </Grid>
    </Box>
  );
}

export default LightningLandersTraits;
